exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-content-wrapper{position:absolute;padding:0;background-color:#fff;width:100%;top:64px;height:calc(100vh - 64px);overflow:auto;display:none}.cap-component-wrapper{max-width:1180px;margin:0 auto;padding:24px 0;height:max-content}\n", ""]);

// exports
